













































































import { Component, PropSync, Vue } from "vue-property-decorator";

@Component
export default class CalendarSyncDialog extends Vue {
    /**
     * If the dialog is open or not.
     */
    @PropSync("open")
    _open: boolean;
}
